import React from "react";
import ThemeSection from "./ThemeSection";
import { withStyles } from "@material-ui/core/styles";
import ThemeOptions from "./ThemeOptions";
import ThemeEditorContainer from "../containers/themeEditor_container";
import IconSelector from "./Shapes/IconOptions";

const Decoration = props => {
    let { theme, icons, classes } = props;

    const headerStyle = [
        {
            value: "none_left",
            label: "Plain",
            src: "/images/theme_editor/Header-None.svg"
        },
        {
            value: "underline_left",
            label: "Underline",
            src: "/images/theme_editor/Header-Underline.svg"
        },
        {
            value: "bar_left",
            label: "Left Bar",
            src: "/images/theme_editor/Header-Left-Bar.svg"
        },
        {
            value: "bar_top_left",
            label: "Top Bar",
            src: "/images/theme_editor/Header-Top-Bar.svg"
        },
        {
            value: "block_left",
            label: "Block",
            src: "/images/theme_editor/Header-Block.svg"
        }
    ];

    const headerAlignment = [
        {
            value: "left",
            label: "Left",
            src: "/images/theme_editor/Header-Align-Left.svg"
        },
        {
            value: "center",
            label: "center",
            src: "/images/theme_editor/Header-Align-Center.svg"
        }
    ];

    const shapeType = [
        {
            value: "none",
            label: "None",
            src: "/images/theme_editor/Shape-None.svg"
        },
        {
            value: "circle",
            label: "Circle",
            src: "/images/theme_editor/Shape-Circle.svg"
        },
        {
            value: "rect",
            label: "Square",
            src: "/images/theme_editor/Shape-Rectangle.svg"
        },
        {
            value: "rounded_rect",
            label: "Rounded",
            src: "/images/theme_editor/Shape-Rounded.svg"
        },
        {
            value: "octagon",
            label: "Octagon",
            src: "/images/theme_editor/Shape-Octagon.svg"
        }
    ];

    const shapeStyle = [
        {
            value: "outlined",
            label: "Outline",
            src: "/images/theme_editor/Shape-Outline.svg"
        },
        {
            value: "muted",
            label: "Muted",
            src: "/images/theme_editor/Shape-Muted.svg"
        },
        {
            value: "filled",
            label: "Filled",
            src: "/images/theme_editor/Shape-Filled.svg"
        },
        {
            value: "fillAndStroke",
            label: "Fill & Stroke",
            src: "/images/theme_editor/Shape-Fill-Stroke.svg"
        }
    ];

    const lineWeight = [
        {
            value: "light",
            label: "Light",
            src: "/images/theme_editor/Line-Light.svg"
        },
        {
            value: "medium",
            label: "Medium",
            src: "/images/theme_editor/Line-Medium.svg"
        },
        {
            value: "heavy",
            label: "Heavy",
            src: "/images/theme_editor/Line-Heavy.svg"
        }
    ];

    const effect = [
        {
            value: "none",
            label: "None",
            src: "/images/theme_editor/Effect-None.svg"
        },
        {
            value: "shadow",
            label: "Shadow",
            src: "/images/theme_editor/Effect-Shadow.svg"
        }
    ];

    return (
        <ThemeSection title="Decoration">
            <ThemeOptions
                options={headerStyle}
                title="Header Style"
                property="styleDecoration"
                selected={theme.styleDecoration}
                update={props.update}
                theme={theme}
            />
            <ThemeOptions
                options={headerAlignment}
                title="Header Alignment"
                property="styleDecoration"
                selected={theme.styleDecoration}
                update={props.update}
                theme={theme}
            />
            <div className={classes.iconStyle}>
                <h4>Icon Style</h4>
                <IconSelector
                    update={props.update}
                    theme={theme}
                    icons={icons}
                />
            </div>
            <ThemeOptions
                options={shapeType}
                title="Shape Type"
                property="styleShape"
                update={props.update}
                theme={theme}
            />
            <ThemeOptions
                options={shapeStyle}
                title="Shape Style"
                property="styleElementStyle"
                update={props.update}
                theme={theme}
            />
            <div>
                <ThemeOptions
                    options={lineWeight}
                    title="Line Weight"
                    property="styleWeight"
                    update={props.update}
                    theme={theme}
                    rootStyle={classes.inlineRow}
                />
                <ThemeOptions
                    options={effect}
                    title="Effect"
                    property="styleEffect"
                    update={props.update}
                    theme={theme}
                    rootStyle={classes.inlineRow}
                />
            </div>
        </ThemeSection>
    );
};

const DecorationStyle = {
    inlineRow: {
        display: "inline-block",
        marginRight: 20
    },
    iconStyle: {
        marginTop: 18,
        "& h4": {
            float: "left",
            marginTop: 10,
            marginRight: 16
        }
    }
};
export default ThemeEditorContainer(withStyles(DecorationStyle)(Decoration));
